// Port of api/fuel/app/classes/controller/api/monty/custom/rename/delete.php
import DB from 'offline/db'
import CustomRename from 'offline/model/custom/rename'
import Game from 'offline/model/game'
import { currentUser, persist, unauthorised, touchUser } from '../shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return unauthorised()

	var data = params.data || {}
	var gameId = parseInt(data.game, 10) || 0

	var rename = CustomRename.record({
		where: {
			user_id: user.get_id(),
			game_id: gameId
		}
	})

	if (!rename) return unauthorised()

	DB.run('DELETE FROM custom_rename WHERE custom_rename_id = ?', [rename.get_id()])
	touchUser(user)

	var game = Game.with_id(rename.get_game_id())

	return persist({
		game: game ? game.get_id() : gameId,
		text: game ? game.get_name() : ''
	})
}
